const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/projects/touring.$id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_rootLayout/projects/touring/$id')({
  preload: false,
  loader: async ({
    params
  }) => window.location.replace(`${process.env.PUBLIC_DREAMHAUS_URL}/projects/touring/${params.id}`),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});